/*
 * @Author: xuyangt
 * @Description: 
 * @Date: 2024-07-18 14:36:18
 * @LastEditTime: 2024-07-18 14:59:19
 */
import { ajax, getAppReqParam } from '@platform/api';

export function getQuerySchemeList({ appCode, pageCode, metaId }){
    return new Promise((resolve, reject) => {
        let appReqParam = getAppReqParam();
        let appcode = appCode || appReqParam.appcode;
        let pagecode = pageCode || appReqParam.pagecode;
        ajax({
            url: '/nccloud/platform/templet/getqueryschemelist.do',
            async: true, //请求是否异步,等待接口返回数据后再执行
            data: { appcode, pagecode, metaid:metaId },
            success: res => {
                if (res.success) {
                    resolve(res.data);
                }
            },
            error: e => {
                reject(e);
            },
        });

    });
   
}